<template>
    <!-- Footer Start -->
    <footer class="footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">{{ year }} © Creote Studio Limited</div>
                <div class="col-md-6">
                    <div class="text-md-right footer-links d-none d-md-block">
                        <a href="mailto:hello@creote.com">Support</a>
                        <a href="https://www.creote.com/web/contact/" target="_blank">Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- end Footer -->
</template>

<script>
export default {
    computed: {
        year() {
            return new Date().getFullYear();
        }
    }
};
</script>

<style>
</style>